import InputNumber from './number.vue';
export default InputNumber;


// WEBPACK FOOTER //
// ./src/components/common/inumber/index.js